import * as React from 'react'
import * as css from './BlueprintGraphic.module.css'
import graphic from 'assets/blueprint-graphic.png'

const BlueprintGraphic = props => (
  <img
    className={css.root}
    src={graphic}
    alt=""
    {...props}
  />
)

export default BlueprintGraphic
